define(["require", "exports", "jquery"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.openKlappmodulFromExternalTrigger = exports.openKlappmodul = exports.initKlappmodule = void 0;
    var klappmodulBodySelector = ".klappmodul_body";
    var klappmodulHeadClass = "klappmodul_head";
    var klappmodulHeadSelector = "." + klappmodulHeadClass;
    var isOpenState = "--is-open";
    var klappmodulHeadIsOpenClass = klappmodulHeadClass + isOpenState;
    var klappmodulHeadIsOpenSelector = klappmodulHeadSelector + isOpenState;
    function initKlappmodule($klappmodule) {
        $klappmodule.each(function (index, element) {
            var $klappmodul = $(element);
            var $klappmodulHead = $klappmodul.children(klappmodulHeadSelector);
            // $klappmodulHead.not(klappmodulHeadIsOpenSelector).siblings(klappmodulBodySelector).hide();
            $klappmodulHead.off("click").on('click', function () {
                openKlappmodul($klappmodul);
            });
            $klappmodulHead.each(function (_, headEl) {
                var $head = $(headEl);
                var $interactive = $head.find("[role='button']");
                $interactive.on("keydown", function (event) {
                    if (event.key === "Enter" || event.key === " ") {
                        event.preventDefault();
                        openKlappmodul($klappmodul);
                    }
                });
            });
        });
    }
    exports.initKlappmodule = initKlappmodule;
    function openKlappmodul($klappmodul) {
        var $klappmodulHead = $klappmodul.find(klappmodulHeadSelector);
        var $klappmodulBody = $klappmodulHead.next(klappmodulBodySelector);
        var isExpanded = $klappmodulHead.attr('aria-expanded') === 'true';
        $klappmodulHead.attr('aria-expanded', (!isExpanded).toString());
        if (isExpanded) {
            $klappmodulBody.removeClass('expanded').addClass('collapsed');
        }
        else {
            $klappmodulBody.removeClass('collapsed').addClass('expanded');
        }
        $klappmodulHead.toggleClass(klappmodulHeadIsOpenClass);
    }
    exports.openKlappmodul = openKlappmodul;
    function openKlappmodulFromExternalTrigger($klappmodul) {
        var $klappmodulHead = $klappmodul.find(klappmodulHeadSelector);
        var $klappmodulBody = $klappmodulHead.next(klappmodulBodySelector);
        var isExpanded = $klappmodulHead.attr('aria-expanded') === 'true';
        $klappmodulHead.attr('aria-expanded', (!isExpanded).toString());
        if (isExpanded) {
            $klappmodulBody.removeClass('expanded').addClass('collapsed');
        }
        else {
            $klappmodulBody.removeClass('collapsed').addClass('expanded');
        }
        $klappmodulHead.toggleClass(klappmodulHeadIsOpenClass);
    }
    exports.openKlappmodulFromExternalTrigger = openKlappmodulFromExternalTrigger;
    $(function () {
        initKlappmodule($(".klappmodul"));
    });
});
